// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-aea2dda6] .input-class:hover,[data-v-aea2dda6] .input-class:focus {
  background-color: transparent !important;
}
.search-input-enter-active[data-v-aea2dda6] {
  transition: opacity 0.15s ease 0.05s;
}
.search-input-leave-active[data-v-aea2dda6] {
  transition: opacity 0.1s ease;
}
.search-input-enter-from[data-v-aea2dda6],
.search-input-leave-to[data-v-aea2dda6] {
  opacity: 0;
}
[data-v-aea2dda6] #filterSlot {
  flex-wrap: wrap;
}
@media (min-width: 768px) {
[data-v-aea2dda6] #filterSlot {
    flex-wrap: nowrap;
}
}
[data-v-aea2dda6] #filterSlot .p-dropdown.form-control {
  padding: 13px 16px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
